module.exports = "<ng-container *ngIf=\"row$ && row$.data.length > 0\">\n    <div class=\"related-row\">\n        <item-row [size]=\"'sm'\" [showCopy]=\"false\" [row$]=\"row$\"></item-row>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/related-row/related-row.template.html
// module id = 754
// module chunks = 2